import { Component, Input, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy} from '@angular/core';
import { UtilityService } from '@irb-common/services/utility.service';

@Component({ standalone: false,
  selector: 'tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class TooltipComponent implements AfterViewInit {
  @ViewChild('tooltip') tooltip: ElementRef;
  @ViewChild('tooltipArrow') tooltipArrow: ElementRef;
  @Input() title: string;
  @Input() ref: any;
  @Input() position: string;
  @Input() event: any;
  @Input() useTruncationParent: boolean;
  @Input() verticalOffset: number;
  @Input() horizontalOffset: number;
  @Input() _width: any;
  @Input() class: string;
  top: number = 0;
  left: number = 0;
  arrow_left: number = 0;
  rect: any;

  constructor(private cdRef:ChangeDetectorRef, private util: UtilityService) { }

  ngAfterViewInit(): void {
    this.rect = this.tooltip.nativeElement.getBoundingClientRect();
    this.updatePosition(this.event);
  }

  updatePosition(e?: any, positionOverride?: string) {
    if(typeof e === "undefined") {
      return;
    }

    this.position = (positionOverride) ? positionOverride : this.position;

    let m, t, l, b, r, w, h, targetRect;
    w = this.rect.right - this.rect.left;
    h = this.rect.bottom - this.rect.top;
    let target = (e.target ? e.target : e.srcElement) as HTMLElement;

    if(this.useTruncationParent) {
      target = this.util.getEllipsisHTMLElement(target);
    } 
    
    targetRect = target.getBoundingClientRect();

    switch(this.position) {
      case "top":
        m = (this.tooltip.nativeElement.offsetWidth / 2);
        t = targetRect.top - this.verticalOffset - h;
        l = targetRect.left + (target.offsetWidth / 2) - this.rect.left - m;
        b = t + h;
        r = l + w;

        this.top = t;
        this.left = l;
        this.arrow_left = m;
        break;
      case "right":
        m = (this.tooltip.nativeElement.offsetHeight / 2);
        t = targetRect.top + (target.offsetHeight / 2) - this.rect.top - m;
        l = targetRect.left + (target.offsetWidth + this.horizontalOffset) - this.rect.left;
        b = t + h;
        r = l + w;
        
        this.top = t;
        this.left = l;
        this.arrow_left = -12;
        break;
      case "bottom":
        m = (this.tooltip.nativeElement.offsetWidth / 2);
        t = targetRect.top + (target.offsetHeight + this.verticalOffset) - this.rect.top;
        l = targetRect.left + (target.offsetWidth / 2) - this.rect.left - m;
        b = t + h;
        r = l + w;

        this.top = t;
        this.left = l;
        this.arrow_left = m;
        break;
      case "left":
        m = (this.tooltip.nativeElement.offsetHeight / 2);
        t = targetRect.top + (target.offsetHeight / 2) - this.rect.top - m;
        l = targetRect.left - this.horizontalOffset - w;
        b = t + h;
        r = l + w;
        
        this.top = t;
        this.left = l;
        this.arrow_left = w - 1;
        break;
    }

    if(!positionOverride) {
      if(t < 0) {
        this.updatePosition(e, "bottom");
        return;
      }

      if(b > window.innerHeight) {
        this.updatePosition(e, "top");
        return;
      }

      if(l < 0) {
        this.updatePosition(e, "right");
        return;
      }

      if(r > window.innerWidth) {
        this.updatePosition(e, "left");
        return;
      }
    }

    this.cdRef.detectChanges();
  }
}
